import React, { useEffect, useState } from "react";
import { useDispatch,  } from "react-redux";
import { Button, Modal } from "@mui/material";
import { RecuperarContraseña } from "../../actions";

const RecuperarContrasena = ({isVisible,setIsVisible}) => {
  const dispatch = useDispatch();
  const [input, setInput] = useState({
    email:"",
    dni:""
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput((prevInput) => ({
      ...prevInput,
      [name]: value,
    }));
    }

    const handleSubmit = ()=>{
        dispatch(RecuperarContraseña(input))
        setIsVisible(false) 
        setInput({
            email:"",
            dni:""
        })
    } 



  return (
        <Modal
          open={isVisible}
          onClose={()=>setIsVisible(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="bg-white rounded-md shadow-md p-6 w-full md:w-80 mx-auto mt-10 md:mt-0">
            <div className="flex flex-row space-y-4">
            <h2 id="modal-modal-title" className="text-lg font-medium mb-4">
              RECUPERAR CONTRASEÑA
            </h2>
            </div>
            <label>Ingrese su E-mail:</label>
            <input
                onChange={handleChange}
                name="email"
                placeholder="Ingrese su E-mail"
                className="border border-gray-400 rounded-md py-2 px-4"
            />
            <br/>
            <label>Ingrese su DNI:</label>
            <input
                onChange={handleChange}
                name="dni"
                placeholder="Ingrese su DNI"
                className="border border-gray-400 rounded-md py-2 px-4"
            />
            <br/>
            <br/>
            <button onClick={handleSubmit} className="bg-green-700 text-white py-2 px-4 rounded-md"> Recuperar Contraseña</button>
            </div>
        </Modal>
  );
};

export default RecuperarContrasena;
